import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import moneda from '../../moneda';
import { Link as Anchor } from "react-router-dom";
import logoRuta20 from '../../../images/4.png';

const COLOR_MARCA = [100, 22, 19]; // #641613: mismo bordó que usa el sitio (sidebar/admin)
const MESES_ES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

// PDO/MySQL suele devolver columnas numéricas como string ("0"/"1"), y en JS
// "0" es truthy -> un simple !!valor lee mal un "0". Esta función lo evalúa bien
// sea number, string o boolean.
const esValorActivo = (valor) => valor === 1 || valor === '1' || valor === true;

// Convierte una imagen (URL remota o import local) a base64 para poder
// incrustarla con jsPDF. Si falla (sin imagen, CORS, 404), devuelve null
// y el llamador cae al placeholder del logo, tal como hace Detail.jsx.
const cargarImagenComoBase64 = async (url) => {
    if (!url) return null;
    try {
        const response = await fetch(url);
        if (!response.ok) return null;
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.warn('No se pudo cargar imagen para el PDF:', url, error);
        return null;
    }
};

const formatoMimeAJsPdf = (dataUrl) => {
    if (!dataUrl) return 'PNG';
    if (dataUrl.startsWith('data:image/jpeg') || dataUrl.startsWith('data:image/jpg')) return 'JPEG';
    if (dataUrl.startsWith('data:image/webp')) return 'WEBP';
    return 'PNG';
};

export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [nuevoAnio, setNuevoAnio] = useState('');
    const [nuevaTransmision, setNuevaTransmision] = useState('');
    const [nuevoCombustible, setNuevoCombustible] = useState('');
    const [nuevaMarca, setNuevaMarca] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroCategoria2, setFiltroCategoria2] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [filtroAnio, setFiltroAnio] = useState('');
    const [filtroTransmision, setFiltroTransmision] = useState('');
    const [filtroCombustible, setFiltroCombustible] = useState('');
    const [filtroMarca, setFiltroMarca] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [categorias, setCategoras] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [nuevoStock, setNuevoStock] = useState('');

    // new fields 
    const [nuevaImagen5, setNuevaImagen5] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [engine, setEngine] = useState('');
    const [width, setWidth] = useState('');
    const [cooling, setCooling] = useState('');
    const [height, setHeight] = useState('');
    const [fuel, setFuel] = useState('');
    const [seatHeight, setSeatHeight] = useState('');
    const [displacement, setDisplacement] = useState('');
    const [frontWheel, setFrontWheel] = useState('');
    const [maxPower, setMaxPower] = useState('');
    const [rearWheel, setRearWheel] = useState('');
    const [maxSpeed, setMaxSpeed] = useState('');
    const [frontBrake, setFrontBrake] = useState('');
    const [rearBrake, setRearBrake] = useState('');
    const [starter, setStarter] = useState('');
    const [tank, setTank] = useState('');
    const [weight, setWeight] = useState('');
    const [alarm, setAlarm] = useState('');
    const [length, setLength] = useState('');
    const [warranty, setWarranty] = useState('');
    const [isMotorcycle, setIsMotorcycle] = useState(false);


    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };

    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };

    useEffect(() => {
        cargarProductos();
    }, []);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo);
        setNuevaDescripcion(producto.descripcion);
        setNuevoPrecio(producto.precio);
        setNuevoMasVendido(producto.masVendido);
        setNuevaCategoria(producto.idCategoria);
        setNuevoAnio(producto.anio);
        setNuevaTransmision(producto.transmision);
        setNuevoCombustible(producto.combustible);
        setNuevaMarca(producto.idMarca);
        setItem1(producto.item1);
        setItem2(producto.item2);
        setItem3(producto.item3);
        setItem4(producto.item4);
        setItem5(producto.item5);
        setItem6(producto.item6);
        setItem7(producto.item7);
        setItem8(producto.item8);
        setItem9(producto.item9);
        setItem10(producto.item10);
        setNuevoPrecioAnterior(producto.precioAnterior);
        setNuevoStock(producto.stock);

        setEngine(producto.engine);
        setWidth(producto.width);
        setCooling(producto.cooling);
        setHeight(producto.height);
        setSeatHeight(producto.seatHeight);
        setDisplacement(producto.displacement);
        setFrontWheel(producto.frontWheel);
        setMaxPower(producto.maxPower);
        setRearWheel(producto.rearWheel);
        setMaxSpeed(producto.maxSpeed);
        setFrontBrake(producto.frontBrake);
        setRearBrake(producto.rearBrake);
        setStarter(producto.starter);
        setTank(producto.tank);
        setWeight(producto.weight);
        setAlarm(producto.alarm);
        setLength(producto.length);
        setWarranty(producto.warranty);
        setFuel(producto.fuel);
        setIsMotorcycle(producto.isMotorcycle);
    }, [producto]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                console.log(data.productos)
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        setNuevaCategoria(producto.idCategoria);
        setNuevoAnio(item.anio);
        setNuevaTransmision(item.transmision);
        setNuevoCombustible(item.combustible);
        setNuevaMarca(item.idMarca);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = item.idCategoria?.toString().includes(filtroCategoria) || false;
        const masVendidoMatch = !filtroMasVendido || item.masVendido?.includes(filtroMasVendido);
        const categoriasMatch = !filtroCategoria2 || item.categoria?.includes(filtroCategoria2);
        const anioMatch = !filtroAnio || item.anio?.toString().includes(filtroAnio);
        const transmisionMatch = !filtroTransmision || item.transmision?.includes(filtroTransmision);
        const combustibleMatch = !filtroCombustible || item.combustible?.includes(filtroCombustible);

        // Corrección principal: manejar idMarca null/undefined
        const marcaMatch = !filtroMarca || (item.idMarca?.toString().includes(filtroMarca) || false);

        return idMatch && tituloMatch && categoriaMatch && masVendidoMatch && categoriasMatch &&
            anioMatch && transmisionMatch && combustibleMatch && marcaMatch;
    });

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => {
            // Buscar el nombre de la categoría
            const categoria = categorias.find(cat => cat.idCategoria === item.idCategoria);
            const nombreCategoria = categoria ? categoria.categoria : 'Sin categoría';

            // Buscar el nombre de la marca
            const marca = marcas.find(mar => mar.idMarca === item.idMarca);
            const nombreMarca = marca ? marca.nombre : 'Sin marca';

            return {
                IdProducto: item.idProducto,
                Titulo: item.titulo,
                Descripcion: item.descripcion,
                Precio: item.precio,
                Categoria: nombreCategoria,
                Marca: nombreMarca,
                Anio: item.anio,
                Transmision: item.transmision,
                Combustible: item.combustible,
                Stock: item.stock,
                PrecioAnterior: item.precioAnterior,
                MasVendido: item.masVendido,
                Fecha: item.createdAt,
                Imagen1: item.imagen1,
                Imagen2: item.imagen2,
                Imagen3: item.imagen3,
                Imagen4: item.imagen4,
            };
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    const descargarPDF = async () => {
        toast.info('Generando PDF...');

        const PAGE_W = 210, PAGE_H = 297;
        const MARGIN = 10;
        const HEADER_H = 26;
        const FOOTER_H = 14;
        const CONTENT_TOP = HEADER_H + 6;
        const CONTENT_BOTTOM = PAGE_H - FOOTER_H - 4;
        const CONTENT_X = MARGIN;
        const CONTENT_W = PAGE_W - MARGIN * 2;

        // Logo del sitio como base64 (placeholder de cada fila sin foto propia,
        // y también el que va en el header de cada página).
        const logoBase64 = await cargarImagenComoBase64(logoRuta20);

        const pdf = new jsPDF({ unit: 'mm', format: 'a4' });

        const dibujarHeader = () => {
            // Zona izquierda: nombre del concesionario
            pdf.setFillColor(255, 255, 255);
            pdf.rect(0, 0, PAGE_W, HEADER_H, 'F');
            pdf.setTextColor(...COLOR_MARCA);
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(15);
            pdf.text('RUTA 20 MOTOS', 8, HEADER_H / 2 + 2);

            // Zona central: título + mes/año
            pdf.setFillColor(...COLOR_MARCA);
            pdf.rect(65, 0, 85, HEADER_H, 'F');
            pdf.setTextColor(255, 255, 255);
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(13);
            pdf.text('LISTA DE PRECIOS', 65 + 42.5, HEADER_H / 2 - 1, { align: 'center' });
            const ahora = new Date();
            pdf.setFontSize(10);
            pdf.setFont('helvetica', 'normal');
            pdf.text(`${MESES_ES[ahora.getMonth()].toUpperCase()} ${ahora.getFullYear()}`, 65 + 42.5, HEADER_H / 2 + 6, { align: 'center' });

            // Zona derecha: logo sobre fondo negro
            pdf.setFillColor(0, 0, 0);
            pdf.rect(150, 0, 60, HEADER_H, 'F');
            if (logoBase64) {
                const logoW = 42, logoH = 42 / (1567 / 605);
                pdf.addImage(logoBase64, formatoMimeAJsPdf(logoBase64), 150 + (60 - logoW) / 2, (HEADER_H - logoH) / 2, logoW, logoH);
            }
        };

        const dibujarPieDePagina = (numPagina, totalPaginas) => {
            pdf.setFillColor(...COLOR_MARCA);
            pdf.rect(0, PAGE_H - FOOTER_H, PAGE_W, FOOTER_H, 'F');
            pdf.setTextColor(255, 255, 255);
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(8.5);
            pdf.text('Av Fuerza Aérea 3850, Córdoba, Argentina  |  +54 9 3513 47-5771', MARGIN, PAGE_H - FOOTER_H / 2 + 1.5);
            pdf.text(`Pag. ${numPagina} / ${totalPaginas}`, PAGE_W - MARGIN, PAGE_H - FOOTER_H / 2 + 1.5, { align: 'right' });
        };

        dibujarHeader();
        let cursorY = CONTENT_TOP;

        // El PDF respeta los filtros activos en la tabla (productosFiltrados ya
        // los aplica todos: marca, categoría, año, etc.) y además excluye los
        // productos marcados como no visibles (activo = 0) en la página pública.
        const productosParaPdf = productosFiltrados.filter(p => esValorActivo(p.activo));

        // Precarga en paralelo de las miniaturas (o null -> placeholder) para no
        // tener que await dentro del loop de dibujo fila por fila.
        const imagenesBase64 = {};
        await Promise.all(
            productosParaPdf.map(async (item) => {
                imagenesBase64[item.idProducto] = await cargarImagenComoBase64(item.imagen1) || logoBase64;
            })
        );

        const ROW_H = 20;
        const ROW_GAP = 2;
        const THUMB_SIZE = 16;

        const asegurarEspacio = (alturaNecesaria, dibujarContinuacionCategoria) => {
            if (cursorY + alturaNecesaria > CONTENT_BOTTOM) {
                pdf.addPage();
                dibujarHeader();
                cursorY = CONTENT_TOP;
                if (dibujarContinuacionCategoria) dibujarContinuacionCategoria();
            }
        };

        const dibujarBarraCategoria = (nombreCategoria) => {
            pdf.setFillColor(...COLOR_MARCA);
            pdf.rect(CONTENT_X, cursorY, CONTENT_W, 7, 'F');
            pdf.setTextColor(255, 255, 255);
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(11);
            pdf.text(nombreCategoria.toUpperCase(), CONTENT_X + 3, cursorY + 5);
            cursorY += 7;

            pdf.setFillColor(235, 230, 230);
            pdf.rect(CONTENT_X, cursorY, CONTENT_W, 5, 'F');
            pdf.setTextColor(...COLOR_MARCA);
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(8);
            pdf.text('MODELO', CONTENT_X + THUMB_SIZE + 5, cursorY + 3.5);
            pdf.text('PRECIO', PAGE_W - MARGIN - 3, cursorY + 3.5, { align: 'right' });
            cursorY += 5 + 2;
        };

        // Agrupar productos filtrados por categoría, en el mismo orden que la
        // lista de categorías cargada; se omiten categorías sin productos visibles.
        const categoriasConItems = categorias
            .map(cat => ({
                categoria: cat,
                items: productosParaPdf.filter(p => p.idCategoria === cat.idCategoria),
            }))
            .filter(grupo => grupo.items.length > 0);

        // Productos cuya categoría no matchea ninguna de la lista cargada (por las dudas)
        const idsConCategoria = new Set(categoriasConItems.flatMap(g => g.items.map(i => i.idProducto)));
        const sinCategoria = productosParaPdf.filter(p => !idsConCategoria.has(p.idProducto));
        if (sinCategoria.length > 0) {
            categoriasConItems.push({ categoria: { categoria: 'Sin categoría' }, items: sinCategoria });
        }

        for (const grupo of categoriasConItems) {
            asegurarEspacio(7 + 5 + 2 + ROW_H);
            dibujarBarraCategoria(grupo.categoria.categoria);

            for (const item of grupo.items) {
                asegurarEspacio(ROW_H, () => dibujarBarraCategoria(grupo.categoria.categoria + ' (cont.)'));

                const rowTop = cursorY;

                // Miniatura
                const img = imagenesBase64[item.idProducto];
                if (img) {
                    try {
                        pdf.addImage(img, formatoMimeAJsPdf(img), CONTENT_X, rowTop, THUMB_SIZE, THUMB_SIZE);
                    } catch (e) {
                        // Si el formato no es compatible, seguimos sin romper el PDF entero
                    }
                }

                // Marca + Modelo
                const marca = marcas.find(m => m.idMarca === item.idMarca);
                const nombreMarca = marca ? marca.nombre : '';
                pdf.setTextColor(...COLOR_MARCA);
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(10);
                pdf.text(item.titulo || '', CONTENT_X + THUMB_SIZE + 5, rowTop + 6);

                // Descripción corta (una línea, truncada)
                pdf.setTextColor(90, 90, 90);
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(8);
                const anchoDescripcion = 90;
                let descripcion = (nombreMarca ? `${nombreMarca} · ` : '') + (item.descripcion || '');
                const lineasDescripcion = pdf.splitTextToSize(descripcion, anchoDescripcion);
                pdf.text(lineasDescripcion.slice(0, 2), CONTENT_X + THUMB_SIZE + 5, rowTop + 11);

                // Precio
                const precioFormateado = `${moneda} ${String(item?.precio ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
                pdf.setFillColor(...COLOR_MARCA);
                pdf.rect(PAGE_W - MARGIN - 48, rowTop, 48, THUMB_SIZE, 'F');
                pdf.setTextColor(255, 255, 255);
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(10.5);
                pdf.text(precioFormateado, PAGE_W - MARGIN - 3, rowTop + THUMB_SIZE / 2 + 1.5, { align: 'right' });

                // Línea separadora sutil
                cursorY = rowTop + ROW_H;
                pdf.setDrawColor(230, 225, 225);
                pdf.line(CONTENT_X, cursorY, PAGE_W - MARGIN, cursorY);
                cursorY += ROW_GAP;
            }

            cursorY += 3; // espacio entre categorías
        }

        // Pie de página en todas las páginas ya generadas (recién ahora sabemos el total)
        const totalPaginas = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPaginas; i++) {
            pdf.setPage(i);
            dibujarPieDePagina(i, totalPaginas);
        }

        pdf.save('lista-de-precios-ruta20motos.pdf');
        toast.success('PDF generado correctamente.');
    };

    const recargarProductos = () => {
        cargarProductos();
    };

    // Alterna un campo puntual (activo / masVendido) de un producto sin
    // pisar el resto de sus datos, y actualiza el estado local al confirmar.
    const toggleCampoProducto = (idProducto, campo, valorActual) => {
        const nuevoValor = campo === 'masVendido'
            ? (valorActual === 'si' ? 'no' : 'si')
            : (esValorActivo(valorActual) ? 0 : 1);

        fetch(`${baseURL}/productoTogglePut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ campo, valor: nuevoValor }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                    return;
                }
                // Usamos el valor calculado localmente (nuevoValor) en vez del que
                // devuelve el backend: PDO castea el bindParam de :valor a string
                // en algunos casos ("0"/"1"), y "0" es truthy en JS, lo que
                // rompía el toggle al segundo click (se quedaba pegado en 0).
                setProductos(prev => prev.map(p =>
                    p.idProducto === idProducto ? { ...p, [campo]: nuevoValor } : p
                ));
            })
            .catch(error => {
                console.error('Error al actualizar producto:', error);
                toast.error('Error al actualizar el producto.');
            });
    };

    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };

    const handleUpdateText = (idProducto) => {
        const payload = {
            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            nuevoAnio: nuevoAnio !== '' ? nuevoAnio : producto.anio,
            nuevaTransmision: nuevaTransmision !== '' ? nuevaTransmision : producto.transmision,
            nuevoCombustible: nuevoCombustible !== '' ? nuevoCombustible : producto.combustible,
            nuevaMarca: nuevaMarca !== '' ? nuevaMarca : producto.idMarca,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            item1: item1 !== undefined ? item1 : producto.item1,
            item2: item2 !== undefined ? item2 : producto.item2,
            item3: item3 !== undefined ? item3 : producto.item3,
            item4: item4 !== undefined ? item4 : producto.item4,
            item5: item5 !== undefined ? item5 : producto.item5,
            item6: item6 !== undefined ? item6 : producto.item6,
            item7: item7 !== undefined ? item7 : producto.item7,
            item8: item8 !== undefined ? item8 : producto.item8,
            item9: item9 !== undefined ? item9 : producto.item9,
            item10: item10 !== undefined ? item10 : producto.item10,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
            stock: nuevoStock !== '' ? nuevoStock : producto.stock,

            // new fields
            engine: engine !== "" ? engine : producto.engine,
            width: width !== "" ? width : producto.width,
            cooling: cooling !== "" ? cooling : producto.cooling,
            height: height !== "" ? height : producto.height,
            seatHeight: seatHeight !== "" ? seatHeight : producto.seatHeight,
            displacement: displacement !== "" ? displacement : producto.displacement,
            frontWheel: frontWheel !== "" ? frontWheel : producto.frontWheel,
            maxPower: maxPower !== "" ? maxPower : producto.maxPower,
            rearWheel: rearWheel !== "" ? rearWheel : producto.rearWheel,
            maxSpeed: maxSpeed !== "" ? maxSpeed : producto.maxSpeed,
            frontBrake: frontBrake !== "" ? frontBrake : producto.frontBrake,
            rearBrake: rearBrake !== "" ? rearBrake : producto.rearBrake,
            starter: starter !== "" ? starter : producto.starter,
            tank: tank !== "" ? tank : producto.tank,
            weight: weight !== "" ? weight : producto.weight,
            alarm: alarm !== "" ? alarm : producto.alarm,
            length: length !== "" ? length : producto.length,
            warranty: warranty !== "" ? warranty : producto.warranty,
            fuel: fuel !== "" ? fuel : producto.fuel,
            isMotorcycle: isMotorcycle !== "" ? isMotorcycle : producto.isMotorcycle,
        };

        fetch(`${baseURL}/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];

        if (file) {
            // Crear una URL de objeto para la imagen seleccionada
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
        }
    };

    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update'); // Campo adicional para indicar que es una actualización

        if (nuevaImagen) {
            formData.append('imagen1', nuevaImagen);
        }
        if (nuevaImagen2) {
            formData.append('imagen2', nuevaImagen2);
        }
        if (nuevaImagen3) {
            formData.append('imagen3', nuevaImagen3);
        }
        if (nuevaImagen4) {
            formData.append('imagen4', nuevaImagen4);
        }
        if (nuevaImagen5) {
            formData.append('imagen5', nuevaImagen5);
        }

        fetch(`${baseURL}/productoImagePut.php`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');
                }

                return response.json();
            })
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                    console.log(formData)
                } else {
                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
                console.log(formData)
                console.log(idProducto)
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
        cargarMarcas();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar categorias:', error));
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMarcas(data.marca || []);
                console.log(data)
            })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    return (
        <div>
            <ToastContainer />
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <NewProduct />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                            <option value="">Categorias</option>
                            {categorias.map(item => (
                                <option key={item?.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                            ))}
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMarca} onChange={(e) => setFiltroMarca(e.target.value)}>
                            <option value="">Marcas</option>
                            {marcas.map(item => (
                                <option key={item?.idMarca} value={item?.idMarca}>{item?.nombre}</option>
                            ))}
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <input type="number" value={filtroAnio} onChange={(e) => setFiltroAnio(e.target.value)} placeholder='Año' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroTransmision} onChange={(e) => setFiltroTransmision(e.target.value)}>
                            <option value="">Transmisión</option>
                            <option value="Manual">Manual</option>
                            <option value="Automática">Automática</option>
                            <option value="CVT">CVT</option>
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCombustible} onChange={(e) => setFiltroCombustible(e.target.value)}>
                            <option value="">Combustible</option>
                            <option value="Gasolina">Gasolina</option>
                            <option value="Diésel">Diésel</option>
                            <option value="Híbrido">Híbrido</option>
                            <option value="Eléctrico">Eléctrico</option>
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                            <option value="">DESTACADOS</option>
                            <option value="si">Si</option>
                            <option value="no">No</option>
                        </select>
                    </div>

                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>
                </div>
            </div>

            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">
                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>
                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagenes')}
                                >
                                    Editar Imagenes
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Titulo</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio !== '' ? nuevoPrecio : producto.precio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripcion</legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.categoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    >
                                        {categorias
                                            .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                            .map(categoriaFiltrada => (
                                                <option key={categoriaFiltrada.idCategoria} value={producto.categoria}> {categoriaFiltrada.categoria}</option>
                                            ))
                                        }
                                        {categorias.map(item => (
                                            <option key={item?.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Marca</legend>
                                    <select
                                        value={nuevaMarca !== '' ? nuevaMarca : producto.idMarca}
                                        onChange={(e) => setNuevaMarca(e.target.value)}
                                    >
                                        {marcas
                                            .filter(marcaFiltrada => marcaFiltrada.idMarca === producto.idMarca)
                                            .map(marcaFiltrada => (
                                                <option key={marcaFiltrada.idMarca} value={producto.idMarca}> {marcaFiltrada.nombre}</option>
                                            ))
                                        }
                                        {marcas.map(item => (
                                            <option key={item?.idMarca} value={item?.idMarca}>{item?.nombre}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Año</legend>
                                    <input
                                        type="number"
                                        value={nuevoAnio !== '' ? nuevoAnio : producto.anio}
                                        onChange={(e) => setNuevoAnio(e.target.value)}
                                        min="1900"
                                        max="2030"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Transmisión</legend>
                                    <select
                                        value={nuevaTransmision !== '' ? nuevaTransmision : producto.transmision}
                                        onChange={(e) => setNuevaTransmision(e.target.value)}
                                    >
                                        <option value={producto.transmision}>{producto.transmision}</option>
                                        <option value="Manual">Manual</option>
                                        <option value="Automática">Automática</option>
                                        <option value="CVT">CVT</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Combustible</legend>
                                    <select
                                        value={nuevoCombustible !== '' ? nuevoCombustible : producto.combustible}
                                        onChange={(e) => setNuevoCombustible(e.target.value)}
                                    >
                                        <option value={producto.combustible}>{producto.combustible}</option>
                                        <option value="Gasolina">Gasolina</option>
                                        <option value="Diésel">Diésel</option>
                                        <option value="Híbrido">Híbrido</option>
                                        <option value="Eléctrico">Eléctrico</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Motor</legend>
                                    <input
                                        type="text"
                                        id="engine"
                                        name="engine"
                                        value={engine}
                                        onChange={(e) => setEngine(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Ancho(mm)</legend>
                                    <input
                                        type="number"
                                        id="width"
                                        name="width"
                                        value={width}
                                        onChange={(e) => setWidth(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Enfriamiento</legend>
                                    <input
                                        type="text"
                                        id="cooling"
                                        name="cooling"
                                        value={cooling}
                                        onChange={(e) => setCooling(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Altura(mm)</legend>
                                    <input
                                        type="number"
                                        id="height"
                                        name="height"
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Combustible</legend>
                                    <input
                                        type="text"
                                        id="fuel"
                                        name="fuel"
                                        value={fuel}
                                        onChange={(e) => setFuel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Altura del asiento(mm)</legend>
                                    <input
                                        type="number"
                                        id="seatHeight"
                                        name="seatHeight"
                                        value={seatHeight}
                                        onChange={(e) => setSeatHeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Desplazamiento(cc)</legend>
                                    <input
                                        type="number"
                                        id="displacement"
                                        name="displacement"
                                        value={displacement}
                                        onChange={(e) => setDisplacement(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rueda delantera</legend>
                                    <input
                                        type="text"
                                        id="frontWheel"
                                        name="frontWheel"
                                        value={frontWheel}
                                        onChange={(e) => setFrontWheel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Máxima potencia</legend>
                                    <input
                                        type="text"
                                        id="maxPower"
                                        name="maxPower"
                                        value={maxPower}
                                        onChange={(e) => setMaxPower(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rueda trasera</legend>
                                    <input
                                        type="text"
                                        id="rearWheel"
                                        name="rearWheel"
                                        value={rearWheel}
                                        onChange={(e) => setRearWheel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Velocidad máxima(km/h)</legend>
                                    <input
                                        type="number"
                                        id="maxSpeed"
                                        name="maxSpeed"
                                        value={maxSpeed}
                                        onChange={(e) => setMaxSpeed(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Freno delantero</legend>
                                    <input
                                        type="text"
                                        id="frontBrake"
                                        name="frontBrake"
                                        value={frontBrake}
                                        onChange={(e) => setFrontBrake(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Freno trasero</legend>
                                    <input
                                        type="text"
                                        id="rearBrake"
                                        name="rearBrake"
                                        value={rearBrake}
                                        onChange={(e) => setRearBrake(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Arrancadora</legend>
                                    <select
                                        id="starter"
                                        name="starter"
                                        value={starter}
                                        onChange={(e) => setStarter(e.target.value)}
                                    >
                                        <option value="">Selecciona Arrancadora</option>
                                        <option value="electric">Eléctrica</option>
                                        <option value="kick">Patada</option>
                                        <option value="electric-and-kick">Eléctrico y patada</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Tanque(L)</legend>
                                    <input
                                        type="number"
                                        id="tank"
                                        name="tank"
                                        value={tank}
                                        onChange={(e) => setTank(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Peso(kg)</legend>
                                    <input
                                        type="number"
                                        id="weight"
                                        name="weight"
                                        value={weight}
                                        onChange={(e) => setWeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Alarma</legend>
                                    <input
                                        type="text"
                                        id="alarm"
                                        name="alarm"
                                        value={alarm}
                                        onChange={(e) => setAlarm(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Longitud(mm)</legend>
                                    <input
                                        type="number"
                                        id="length"
                                        name="length"
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Garantia</legend>
                                    <input
                                        type="number"
                                        id="warranty"
                                        name="warranty"
                                        value={warranty}
                                        onChange={(e) => setWarranty(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>DESTACADOS</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value={producto.masVendido}>{producto.masVendido}</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                </fieldset>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    width: '49%'
                                }}>
                                    <legend>Motorcycle Specify:</legend>
                                    <input style={{ width: '100%' }}
                                        type="checkbox"
                                        id="isMotorcycle"
                                        value={isMotorcycle}
                                        checked={!!isMotorcycle}
                                        onChange={(e) => setIsMotorcycle(e.target.checked)}
                                    />
                                </div>

                                <fieldset>
                                    <legend>Catalogo</legend>
                                    <input
                                        type="number"
                                        value={nuevoStock !== '' ? nuevoStock : producto.stock}
                                        onChange={(e) => setNuevoStock(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    <fieldset>
                                        <legend>Item 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            required
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 2</legend>
                                        <input
                                            type="text"
                                            id="item2"
                                            name="item2"
                                            required
                                            value={item2}
                                            onChange={(e) => setItem2(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 3</legend>
                                        <input
                                            type="text"
                                            id="item3"
                                            name="item3"
                                            required
                                            value={item3}
                                            onChange={(e) => setItem3(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 4</legend>
                                        <input
                                            type="text"
                                            id="item4"
                                            name="item4"
                                            required
                                            value={item4}
                                            onChange={(e) => setItem4(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 5</legend>
                                        <input
                                            type="text"
                                            id="item5"
                                            name="item5"
                                            required
                                            value={item5}
                                            onChange={(e) => setItem5(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 6</legend>
                                        <input
                                            type="text"
                                            id="item6"
                                            name="item6"
                                            required
                                            value={item6}
                                            onChange={(e) => setItem6(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 7</legend>
                                        <input
                                            type="text"
                                            id="item7"
                                            name="item7"
                                            required
                                            value={item7}
                                            onChange={(e) => setItem7(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 8</legend>
                                        <input
                                            type="text"
                                            id="item8"
                                            name="item8"
                                            required
                                            value={item8}
                                            onChange={(e) => setItem8(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 9</legend>
                                        <input
                                            type="text"
                                            id="item9"
                                            name="item9"
                                            required
                                            value={item9}
                                            onChange={(e) => setItem9(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 10</legend>
                                        <input
                                            type="text"
                                            id="item10"
                                            name="item10"
                                            required
                                            value={item10}
                                            onChange={(e) => setItem10(e.target.value)}
                                        />
                                    </fieldset>
                                </div>
                            </div>

                            <button className='btnPost' onClick={() => handleUpdateText(producto.idProducto)} >Guardar </button>
                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>
                                {imagenPreview ? (
                                    <img src={imagenPreview} alt="Vista previa de la imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />
                                ) : (
                                    <>
                                        {producto.imagen1 ? (
                                            <img src={producto.imagen1} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}

                                {imagenPreview2 ? (
                                    <img src={imagenPreview2} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen2 ? (
                                            <img src={producto.imagen2} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen2)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview3 ? (
                                    <img src={imagenPreview3} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen3 ? (
                                            <img src={producto.imagen3} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen3)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview4 ? (
                                    <img src={imagenPreview4} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen4 ? (
                                            <img src={producto.imagen4} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen4)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview5 ? (
                                    <img src={imagenPreview5} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen5 ? (
                                            <img src={producto.imagen5} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen5)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Editar Imagen1 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen, setImagenPreview)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen2 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen2, setImagenPreview2)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen3 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen3, setImagenPreview3)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen4 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen4, setImagenPreview4)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen5 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen5, setImagenPreview5)} />
                            </fieldset>

                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>
                        </div>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Titulo</th>
                            <th>Precio</th>
                            <th>Categoria</th>
                            <th>Marca</th>
                            <th>Año</th>
                            <th>Transmisión</th>
                            <th>Combustible</th>
                            <th>Imagen</th>
                            <th>Visible</th>
                            <th>Destacado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosFiltrados.map(item => (
                            <tr key={item.idProducto}>
                                <td>{item.titulo}</td>

                                <td style={{
                                    color: '#008000',
                                }}>
                                    {moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>

                                {categorias
                                    .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                    .map(categoriaFiltrada => (
                                        <td
                                            key={categoriaFiltrada.idCategoria}
                                            style={{ color: '#DAA520' }}
                                        >
                                            {categoriaFiltrada.categoria}
                                        </td>
                                    ))
                                }

                                {marcas
                                    .filter(marcaFiltrada => marcaFiltrada.idMarca === item.idMarca)
                                    .map(marcaFiltrada => (
                                        <td
                                            key={marcaFiltrada.idMarca}
                                            style={{ color: '#FF6347' }}
                                        >
                                            {marcaFiltrada.nombre}
                                        </td>
                                    ))
                                }
                                {(!item.idMarca || marcas.filter(marcaFiltrada => marcaFiltrada.idMarca === item.idMarca).length === 0) && (
                                    <td style={{ color: '#999999' }}>
                                        Sin marca
                                    </td>
                                )}

                                <td style={{ color: '#4169E1' }}>{item.anio}</td>
                                <td style={{ color: '#32CD32' }}>{item.transmision}</td>
                                <td style={{ color: '#FF8C00' }}>{item.combustible}</td>

                                <td>
                                    {item.imagen1 ? (
                                        <img src={item.imagen1} alt="imagen1" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>

                                <td>
                                    <label className='toggle-switch' title={esValorActivo(item.activo) ? 'Visible en la página' : 'Oculto de la página'}>
                                        <input
                                            type="checkbox"
                                            checked={esValorActivo(item.activo)}
                                            onChange={() => toggleCampoProducto(item.idProducto, 'activo', item.activo)}
                                        />
                                        <span className='toggle-switch-slider'></span>
                                    </label>
                                </td>

                                <td>
                                    <label className='toggle-switch' title={item.masVendido === 'si' ? 'Producto destacado' : 'No destacado'}>
                                        <input
                                            type="checkbox"
                                            checked={item.masVendido === 'si'}
                                            onChange={() => toggleCampoProducto(item.idProducto, 'masVendido', item.masVendido)}
                                        />
                                        <span className='toggle-switch-slider'></span>
                                    </label>
                                </td>

                                <td>
                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </Anchor>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};